/**
 * @typedef {('TRANSACTION'|'CONTACT'|'FILE_MANAGER')} FileListModule
 */

export const FileListModule = {
    TRANSACTION: 'TRANSACTION',
    CONTACT: 'CONTACT',
    FILE_MANAGER: 'FILE_MANAGER',
};
